import * as React from "react"
import { useState, useEffect, useRef } from "react"
import videojs, { VideoJsPlayer, VideoJsPlayerOptions } from "video.js"
import "video.js/dist/video-js.css"

import "videojs-youtube"

if (typeof window !== "undefined") {
  require("videojs-landscape-fullscreen")
}

interface PlayerProps {
  src: string
  type?: string
  thumb?: string
  subtitles?: videojs.TextTrackOptions[]
}

interface LSFullscreen {
  landscapeFullscreen?: ({}) => void
}

const options: VideoJsPlayerOptions = {
  techOrder: ["youtube", "html5"],
  fluid: true,
  defaultVolume: 0.25,
  userActions: { hotkeys: true },
  preload: "auto",
  controls: true,
}

const Player: React.FC<PlayerProps> = ({ src, type = "video/youtube", thumb, subtitles }) => {
  const videoRef = useRef(null)
  const [player, setPlayer] = useState<VideoJsPlayer | null>(null)

  const tracks: videojs.TextTrackOptions[] = []
  subtitles &&
    subtitles.map(sub => {
      tracks.push({
        kind: "captions",
        src: sub.src,
        label: sub.label,
        language: sub.language,
        default: sub.default,
      })
    })

  useEffect(() => {
    const vjsPlayer: VideoJsPlayer & LSFullscreen = videojs(
      videoRef.current,
      {
        ...options,
        tracks: tracks,
        sources: [{ type, src }],
      },
      function onPlayerReady() {}
    )

    vjsPlayer.landscapeFullscreen &&
      vjsPlayer.landscapeFullscreen({
        fullscreen: {
          enterOnRotate: true,
          alwaysInLandscapeMode: true,
          iOS: true,
        },
      })

    vjsPlayer.volume(options.defaultVolume!)

    setPlayer(vjsPlayer)

    return () => vjsPlayer.dispose()
  }, [])

  useEffect(() => {
    if (player !== null) {
      player.src({ src, type })
    }
  }, [src, type, player])

  if (thumb)
    return (
      <>
        <video
          ref={videoRef}
          className={`video-js`}
          preload="none"
          width="500px"
          poster={thumb}
          data-setup={`{ "preload":"none", "youtube": { "cc_load_policy": 0, "hl": "jp" } }`}
        />
      </>
    )

  return (
    <>
      <video
        ref={videoRef}
        className={`video-js`}
        preload="none"
        data-setup={`{ "preload":"none", "youtube": { "cc_load_policy": 0, "hl": "jp" } }`}
      />
    </>
  )
}

export default Player
